export default __webpack_public_path__ + "static/media/card-healthcare.354b5630.png";